// Fonction pour initialiser les événements de swap d'images
function initStrapSwapEvents() {
  const strapLinks = document.querySelectorAll('.oc_pcard_strap1 button, .oc_pcard_strap2 button, .oc_pcard_strap3 button');
  
  strapLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productCard = this.closest('[id^="pid_"]');
      
      if (productCard) {
        const imageHaut = productCard.querySelector('.oc_strapshaut img');
        const imageBas = productCard.querySelector('.oc_strapsbas img');
        const sourceImg = this.querySelector('img');
        const newSrc = sourceImg.src;
        const newAlt = sourceImg.alt;
        
        if (imageHaut) {
          imageHaut.src = newSrc;
          imageHaut.alt = newAlt;
        }
        
        if (imageBas) {
          imageBas.src = newSrc;
          imageBas.alt = newAlt;
        }
        
        // Gérer la classe 'selected'
        productCard.querySelectorAll('.oc_pcard_visuels img').forEach(img => {
          img.classList.remove('selected');
        });
        
        sourceImg.classList.add('selected');
      }
    });
  });
}

// Attendre que motion-list soit complètement chargé
function waitForMotionList() {
  const motionList = document.querySelector('motion-list');
  
  if (motionList) {
    const observer = new MutationObserver(function(mutations) {
      const hasStrapElements = mutations.some(mutation => 
        mutation.type === 'childList' && 
        Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && 
          node.querySelector && (
            node.querySelector('.oc_pcard_strap1') ||
            node.querySelector('.oc_pcard_strap2') ||
            node.querySelector('.oc_pcard_strap3')
          )
        )
      );
      
      if (hasStrapElements) {
        initStrapSwapEvents();
      }
    });
    
    observer.observe(motionList, {
      childList: true,
      subtree: true
    });
  }
  
  // Une seule initialisation au chargement
  initStrapSwapEvents();
}

// Démarrer quand le DOM est prêt
document.addEventListener('DOMContentLoaded', waitForMotionList);

// Réécouter après chaque rechargement de collection
document.addEventListener('collection:reloaded', initStrapSwapEvents);
